export const Messages = {
  SUCCESS_PROFILE_ADDED: 'Usuario creado exitosamente',
  SUCCESS_PROFILE_ADDED_BODY: 'El usuario puedes encontrarlo en la lista de usuarios',
  GO_TO_LIST_BUTTON_TEXT: 'Ir a lista',
  UPDATE_PROFILE_SUCCESS: 'Usuario actualizado correctamente',
};

